var YMK = window?.YMK || {};
var site = window?.site || {};

(function ($) {
  Drupal.behaviors.productFoundationVtov2 = {
    attach: function (context) {
      var $productFoundationVto;
      var $productFoundationShade;
      var $sdProductSPP;
      var autoTriggerYoucam;
      var hasVtoDiscloseParam;
      var $foundationVtoButton;
      var $foundationVtoQrOverlay;
      var $carouselSectionWrapper;
      var $foundationVtoContainer;
      var $mobileShadePickContainer;
      var $mobileShadePicker;
      var $addToBagButton;
      var $addToBagError;
      var $gwpAddToBagButton;
      var $foundationVtoOverlayContainer;
      var foundationOverlayTemplate;
      var $foundationVtoOverlayButton;
      var $foundationVtoIframe;
      var $swatches;
      var $swatch;
      var $swatchFilter;
      var $foundationOverlayClose;
      var isMob;
      var youcamAPIKey;
      var youcamAPIUrl;
      var language;
      var $seeAllshade;
      var $seeMyPerfect;
      var $bodyElement;
      var foundationResults;
      var shadeSelected;
      var youcamEvents;
      var $vtoElement;
      var $shadeNameContainer;
      var $shadeSwatchContainer;
      var $curMobSwatch;
      var perfectMatch;
      var currentShadeMatchFound;
      var productName;
      var eventName;
      var skuID;
      var data;
      var selectedSku;
      var $shadeElement;
      var skinText;
      var perfectText;
      var filterClass;
      var $activeSwatch;
      var skuBaseId;
      var changeSKUData;
      var windowHeight;

      $productFoundationVto = $('.js-product-foundation-vto-v2', context);
      $productFoundationShade = $('.js-shade-picker-vto', context);
      $sdProductSPP = $('.sd-product-spp', context);

      if (!$productFoundationVto.length || !$productFoundationShade.length) {
        return;
      }

      autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      $foundationVtoButton = $('.js-product-foundation-vto-btn', context);
      $foundationVtoQrOverlay = $('.js-product-full__foundation-qrcode', context);
      $carouselSectionWrapper = $('.js-carousel-section-wrapper', context);
      $foundationVtoContainer = $('.js-product-foundation-vto-container', $productFoundationVto);
      $mobileShadePickContainer = $('.js-product-foundation-shade-container', $productFoundationVto);
      $mobileShadePicker = $('.js-shade-picker-vto', $productFoundationVto);
      $addToBagButton = $('.js-add-to-cart', $productFoundationVto);
      $addToBagError = $('.js-sample-error', $productFoundationVto);
      $gwpAddToBagButton = $('.js-pwp-product__add-button', context);
      $foundationVtoOverlayContainer = $('.js-product-foundation-vto-overlay-container', $productFoundationVto);
      foundationOverlayTemplate = $('script.inline-template[path="foundation_vto_overlay"]').html();

      $foundationVtoOverlayContainer.html(foundationOverlayTemplate);

      // Overlay elements
      $foundationVtoOverlayButton = $('.js-product-foundation-vto-overlay-button', $productFoundationVto);

      $foundationVtoOverlayButton.removeClass('disabled');
      $foundationVtoIframe = $('.js-product-foundation-vto-iframe', $productFoundationVto);
      $swatches = $('.js-swatches', $mobileShadePicker);
      $swatch = $('.js-swatch', $mobileShadePicker);
      $swatchFilter = $('.js-vto-filter-text', $swatches);
      $foundationOverlayClose = $('.js-product-foundation-vto-overlay-close', $productFoundationVto);
      isMob = site.client.isMobile || (Unison && Unison.fetch && Unison.fetch.now().name === 'small'); ;
      youcamAPIKey = Drupal.settings.foundation_vto.api_key;
      youcamAPIUrl = Drupal.settings.foundation_vto.api_url;
      language = Drupal.settings.foundation_vto.language;
      $seeAllshade = $('.js-see-all-shade', $productFoundationVto);
      $seeMyPerfect = $('.js-see-perfect', $productFoundationVto);
      $bodyElement = $('body', context);
      foundationResults = [];
      shadeSelected = false;
      youcamEvents = [
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderCancelled',
        'skinShadeFound',
        'zoom',
        'cameraClosed',
        'engineClosed',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];

      if (isMob) {
        $vtoElement = $foundationVtoContainer.remove();

        $vtoElement.appendTo($bodyElement);

        $foundationVtoOverlayContainer.find('.js-vto-disclaimer-checkbox').remove();

        $addToBagButton.on('click', function () {
          $gwpAddToBagButton.trigger('click');
          $addToBagButton.attr('disabled', 'disabled');
        });

        $mobileShadePickContainer.addClass('product-foundation-vto__container-shades');
      }

      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      function chatButtonToggle() {
        var $chatIconContainer = $('.wo-inline', context);
        var $chatIconButton = $chatIconContainer.find('.wo-chat-btn');

        if ($chatIconButton.length) {
          $chatIconButton.toggleClass('hidden');
        }
      }

      function openYoucamModule() {
        var $mobileChatLabel = $('.lt-label-chat');
        var $chatLiveButton = $('.LPMcontainer');

        chatButtonToggle();
        $foundationVtoButton.addClass('hidden');
        $foundationVtoContainer.removeClass('hidden');
        $foundationVtoOverlayContainer.removeClass('hidden');

        if (hasVtoDiscloseParam) {
          $foundationOverlayClose.addClass('hidden');
        }

        $foundationVtoIframe.addClass('hidden');
        autoTriggerYoucam = false;
        window.scrollTo(0, 0);
        $bodyElement.addClass('no-scroll');
        $chatLiveButton.addClass('hidden');
        $mobileChatLabel.addClass('hidden');
      }

      function skinShadeFilter() {
        if (foundationResults.readableRecommendations?.length) {
          perfectMatch = foundationResults.readableRecommendations[0];
          currentShadeMatchFound = 0;

          if (perfectMatch) {
            $swatches.removeClass('vto-filter first-filter best-match');
            $.each(perfectMatch, function (skin, skinData) {
              if ($.isNumeric(skinData)) {
                return;
              }

              $shadeElement = $mobileShadePicker
                .find('.js-swatch[data-product-code="' + skinData + '"]')
                .closest('.js-swatches');

              if ($shadeElement.length) {
                currentShadeMatchFound = 1;
                skinText = $productFoundationVto.attr('data-foundation-' + skin);
                perfectText = skin === 'guid' ?
                  $productFoundationVto.attr('data-foundation-perfect') :
                  skinText;
                filterClass = skin === 'guid' ? 'best-match vto-filter' : 'vto-filter';

                $shadeElement
                  .addClass(filterClass)
                  .find('.js-vto-filter-text')
                  .html(skinText)
                  .attr('data-filter-text', perfectText);
              }
            });

            $mobileShadePicker.find('.vto-filter').first().addClass('first-filter');
          }

          if (currentShadeMatchFound) {
            $seeMyPerfect.addClass('active');
          } else {
            $seeMyPerfect.removeClass('active');
          }
        }

        $mobileShadePicker.find('.js-swatch').each(function () {
          var $this = $(this);
          var [shadeCode, shadeName] = $this.text()?.split(' ', 2);

          if (!$this.find('.js-shade-code').length) {
            $this.html(
              '<span class="shade-code js-shade-code">' + shadeCode + '</span>' + shadeName
            );
          }
        });
      }

      function changeSKU(swatch) {
        if (!page_data?.skus) {
          return;
        }

        skuBaseId = swatch.data('sku-base-id');

        shadeSelected = false;

        changeSKUData = _.find(page_data?.fullSizeSkus, function (sku) {
          return sku.SKU_BASE_ID === skuBaseId;
        });

        $sdProductSPP.attr('data-product-id', changeSKUData.PRODUCT_ID);
        site.skuSelect(changeSKUData);
        $addToBagButton.removeClass('disabled');
        $addToBagError.addClass('hidden');
        var $sampleSku = $sdProductSPP.find(`.js-pwp-product-hex-grid .js-color-box[data-full-size-sku-id="${changeSKUData.PRODUCT_CODE}"]`);

        if ($sampleSku.length && !$sampleSku.hasClass('promo-sold-out')) {
          $sampleSku.trigger('click');
        } else {
          $addToBagError.removeClass('hidden');
          $addToBagButton.addClass('disabled');
        }
        $sdProductSPP.find('.js-offer-selection .js-offer-selection__dropdown-menu').hide();
      }

      function closeYoucamModule() {
        var $mobileChatLabel = $('.lt-label-chat');
        var $chatLiveButton = $('.LPMcontainer');

        chatButtonToggle();
        $foundationVtoContainer.addClass('hidden');
        $foundationVtoButton.removeClass('hidden');
        $swatches.removeClass('vto-filter first-filter selected active best-match');
        $swatchFilter.html('');

        if (isMob) {
          $bodyElement.removeClass('no-scroll');
          $chatLiveButton.removeClass('hidden');
          $mobileChatLabel.removeClass('hidden');
        }

        window.YMK.closeEngine();
        $mobileShadePickContainer.removeClass('active');

        if (hasVtoDiscloseParam) {
          openYoucamModule();
        }
      }

      function toggleMobileShadePick(state) {
        if (state === 'on') {
          $activeSwatch = $mobileShadePicker.find('a.selected');

          $mobileShadePickContainer.removeClass('hidden');
          $mobileShadePicker.scrollTo($activeSwatch, {
            duration: 350,
            offset: -40
          });
        } else {
          $mobileShadePickContainer.addClass('hidden');
        }
      }

      window.ymkAsyncInit = function (skipEventListener) {
        var productID = $addToBagButton.data('product-id').replace('PROD', '');
        var vtoParams = {
          showCloseBtnOnLauncher: true,
          bottomPanelOffsetY: $mobileShadePickContainer.height() + 5,
          skinSmoothStrength: 0
        };

        if (Drupal.settings.foundation_vto.is_product_list_enabled) {
          vtoParams.productIdList = [productID];
        }

        if (language) {
          vtoParams.language = language;
        }

        window.YMK.init(vtoParams);

        if (skipEventListener) {
          return;
        }

        youcamEvents.forEach(function (vtoEvent) {
          window.YMK.addEventListener(vtoEvent, function (result) {
            if (vtoEvent === 'compare' || vtoEvent === 'compareDisabled') {
              $mobileShadePickContainer.addClass('active');
            } else {
              $mobileShadePickContainer.removeClass('active');
              $swatches.removeClass('vto-filter first-filter active best-match');
              $swatchFilter.html('');
            }

            if (vtoEvent === 'loaded' && isMob) {
              toggleMobileShadePick('on');
            }

            if (vtoEvent === 'opened' && autoTriggerYoucam) {
              $foundationVtoButton.addClass('hidden');
            }

            if (vtoEvent === 'closed') {
              if (isMob) {
                toggleMobileShadePick('off');
              }
              closeYoucamModule();
            }

            if (vtoEvent === 'skinShadeFound' && result.readableRecommendations) {
              foundationResults = result;
              skinShadeFilter();
              $mobileShadePickContainer.addClass('active');
              $seeMyPerfect.removeClass('active');

              if ($mobileShadePicker.find('.vto-filter').length) {
                $seeAllshade.addClass('active');
                $swatches.removeClass('active');
                changeSKU($mobileShadePicker.find('.vto-filter.best-match .js-swatch'));
              } else {
                $seeAllshade.removeClass('active');
                $swatches.addClass('active');
                changeSKU($mobileShadePicker.find('.js-swatch').first());
              }
            }

            // Analytics
            if (site && site.track) {
              data = site.track.refreshData();

              if (data?.product_name?.length && data?.product_sku?.length) {
                productName = data.product_name[0].replace(/(<([^>]+)>)/giu, '');
                skuID = data.product_sku[0];
              }

              selectedSku = $swatch.filter('.selected').data('sku-base-id');

              if (selectedSku) {
                skuID = 'SKU' + selectedSku;
              }

              if (vtoEvent === 'loading') {
                if (result === 10) {
                  eventName = 'loading';
                } else if (result === 100) {
                  eventName = 'loaded';
                }
              } else {
                eventName = vtoEvent;
              }

              if (eventName) {
                site.track.evtLink({
                  event_name: 'vto',
                  event_category: 'youcam',
                  event_action: eventName,
                  event_label: skuID + ' - ' + productName
                });
              }
            }
          });
        });

        if (autoTriggerYoucam) {
          openYoucamModule();
        }
      };

      $foundationVtoOverlayButton.once().on('click', function (e) {
        e.preventDefault();
        $foundationVtoOverlayContainer.addClass('hidden');
        $foundationVtoIframe.removeClass('hidden');
        window.YMK.open(true, null, true);
      });

      $seeAllshade.once().on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $seeMyPerfect.addClass('active');
        $swatches.addClass('active');
        $mobileShadePickContainer.removeClass('product-foundation-vto__container-shades');
        $mobileShadePicker.scrollTo($mobileShadePicker.find('a.selected'), {
          duration: 350,
          offset: -40
        });
      });

      $seeMyPerfect.once().on('click', function (e) {
        e.preventDefault();
        $(this).removeClass('active');
        $seeAllshade.addClass('active');
        $swatches.removeClass('active');
        $mobileShadePickContainer.addClass('product-foundation-vto__container-shades');
        changeSKU($mobileShadePicker.find('.vto-filter.best-match .js-swatch'));
      });

      $foundationOverlayClose.once().on('click', function (e) {
        e.preventDefault();
        closeYoucamModule();
      });

      $swatch.once().on('click', function () {
        changeSKU($(this));
      });

      $bodyElement.on('sku:select', function (e, skuData) {
        if (shadeSelected) {
          return;
        }

        $shadeNameContainer = $('.js-shadename', $mobileShadePickContainer);
        $shadeSwatchContainer = $('.js-current-swatch', $mobileShadePickContainer);
        $curMobSwatch = $mobileShadePickContainer.find(
          'a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]'
        );

        $mobileShadePickContainer.find('a.js-swatch').removeClass('selected');
        $swatches.removeClass('selected');
        $curMobSwatch.addClass('selected').closest('.swatches--single').addClass('selected');
        $shadeNameContainer.html(skuData.SHADENAME);
        $shadeSwatchContainer.css('background-color', '#' + skuData.HEX_VALUE);

        if (YMK && YMK.applyMakeupBySku) {
          YMK.applyMakeupBySku(skuData.PRODUCT_CODE);
        }

        $foundationVtoButton.toggleClass('hidden', !skuData.VTO_FOUNDATION_ONLINE);
        shadeSelected = true;
      });

      $foundationVtoButton.once().on('click', function (e) {
        e.preventDefault();
        if (isMob) {
          openYoucamModule();
        } else {
          $carouselSectionWrapper.addClass('hidden');
          $foundationVtoQrOverlay.removeClass('hidden');
        }
      });

      window.GlobalServiceBus?.on(
        window.ServiceBusTopics.events.VTO_FOUNDATION_QR_CODE_OVERLAY_CLOSED,
        function () {
          $foundationVtoQrOverlay.addClass('hidden');
          $carouselSectionWrapper.removeClass('hidden');
        }
      );
    }
  };
})(jQuery);
